export default __webpack_public_path__ + "static/media/Crown logo.6bca3ede.svg";